import { WIZ_BOOLEAN } from '../models/enums';

// méthodes utilitaires sur base numérique
export class WizMathUtils {
  //  génération d'un UUID
  // @return UUID xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
  public static createUUID(): string {
    let dt = new Date().getTime();
    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = (dt + Math.random() * 16) % 16 | 0;
      dt = Math.floor(dt / 16);
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
    return uuid;
  }

  /**
   * comparaison de chaine sur 53 bits (pour sélections)
   */
  public static wizBitwize(value1, value2) {
    const maxInt32Bits = 4294967296; // 2^32

    const value1highBits = value1 / maxInt32Bits;
    const value1lowBits = value1 % maxInt32Bits;
    const value2highBits = value2 / maxInt32Bits;
    const value2lowBits = value2 % maxInt32Bits;
    return (value1highBits & value2highBits) * maxInt32Bits + (value1lowBits & value2lowBits);
  }

  /**
   * conversion d'un string en Boolean. Prise en compte du null
   */
   public static stringToBoolean(value: string): WIZ_BOOLEAN {
    if (value === '1') {
      return WIZ_BOOLEAN.TRUE;
    } else if (value === '0') {
      return WIZ_BOOLEAN.FALSE;
    } else {
      return WIZ_BOOLEAN.UNKNOWN;
    }
  }

  /**
   * conversion d'un Boolean en string. Prise en compte du null
   */
  public static booleanToString(value: WIZ_BOOLEAN): string {
    if (value === WIZ_BOOLEAN.TRUE) {
      return '1';
    } else if (value === WIZ_BOOLEAN.FALSE) {
      return '0';
    } else {
      return null;
    }
  }

  
}
